import { mdiDotsVertical } from '@mdi/js';
import Icon from '@mdi/react';
import React from 'react';
import { BaseButton } from '../../../base/button';
import * as S from './selection-actions-fab.styles';

// A plain header row above the menu actions. `Popover` clones every direct child with
// `closeMenu`/`pinned`/`selectable`/`openSubmenu`/`closeSubmenu` (see base `Popover.renderChildren`);
// declaring — and swallowing — those props here keeps them from landing on the underlying `<div>` as
// unrecognized DOM attributes.
const FabMenuLabel: React.FC<{
    children?: React.ReactNode;
    closeMenu?: () => void;
    pinned?: boolean;
    selectable?: boolean;
}> = ({ children }) => <S.FabMenuLabel>{children}</S.FabMenuLabel>;

export interface ISelectionActionsFabProps {
    selectedCount: number;
    /** Singular noun for the selected rows — "claim" renders "3 claims selected". */
    noun: string;
    disabled?: boolean;
    /**
     * `PopoverItem`s, passed directly. `Popover` injects `closeMenu` into its direct children only,
     * so items wrapped in a Fragment would never close the menu.
     */
    children?: React.ReactNode;
}

/** Batch actions for the selected table rows: a floating ⋮ button bottom-right, hidden when nothing is selected. */
export const SelectionActionsFab: React.FC<ISelectionActionsFabProps> = ({
    selectedCount,
    noun,
    disabled,
    children,
}) => {
    if (selectedCount === 0) {
        return null;
    }

    return (
        <S.FabContainer>
            <S.FabPopover
                align="right"
                verticalAlign="top"
                renderButton={() => (
                    <BaseButton variant="fab-light" size="large" disabled={disabled}>
                        <Icon path={mdiDotsVertical} size={1} />
                    </BaseButton>
                )}
            >
                <FabMenuLabel>
                    {selectedCount} {noun}
                    {selectedCount === 1 ? '' : 's'} selected
                </FabMenuLabel>
                {children}
            </S.FabPopover>
        </S.FabContainer>
    );
};
